import PagesIcon from '@material-ui/icons/Pages';

import List from './List';

export default {
  list: List,
  icon: PagesIcon,
};
